export const bestbetsProperties: { [key: string]: string } = {
    Title:'Title',
    description: 'description',
    vertical: 'vertical',
    detailPath: 'detailPath',
    aboutme: 'aboutme',
    contentType: 'contentType',
    EYKREIKeywords : 'EYKREIKeywords',
    EYKREIDescription : 'EYKREIDescription',
    EYKREIBestbetUrl: 'EYKREIBestbetUrl',
    eydescription:'eydescription',
    hitHighlightedProperties: 'HitHighlightedProperties',
    eyaemId: 'eyaemId',
    createdDate: 'createdDate',
  };
  